// eslint-disable-next-line import/no-unresolved
import AppConfig from 'appconfig';

const LOCALSTORAGE_KEY = 'hubAdmin';

export default class LocalStorageStore {
    constructor(environment) {
        this.environment = environment;
    }

    getLocalStorageItem() {
        try {
            return JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY)) || {};
        } catch {
            return {};
        }
    }

    setLocalStorageItem(item) {
        try {
            localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(item));
        } catch (error) {
            console.error('Error setting localstorage', error);
        }
    }

    changeEnvironment(newEnvironment) {
        // Fallback when the default page is NOT the environement selector (use case on the production environment)
        // Use the first (and most likely) only enviroment in the AppConfig
        if (newEnvironment === null || newEnvironment === 'null' || !AppConfig.availableEnvs[newEnvironment]) {
            newEnvironment = Object.keys(AppConfig.availableEnvs)[0];
        }

        // Set the new environment
        this.environment = newEnvironment;

        // Set the AppConfig to the new environment and save the new environment in the localStorage, so
        // the application can load into the correct environment when it gets refreshed

        AppConfig.activeEnvironment = AppConfig.availableEnvs[newEnvironment];

        const item = this.getLocalStorageItem();
        item.lastUsedEnvironment = newEnvironment;
        this.setLocalStorageItem(item);
    }

    setLastUsedEnvironment() {
        const item = this.getLocalStorageItem();
        this.changeEnvironment(item.lastUsedEnvironment);
    }

    set(key, value) {
        const item = this.getLocalStorageItem();
        item[key] = value;
        this.setLocalStorageItem(item);
    }

    get(key) {
        const item = this.getLocalStorageItem();
        return item[key];
    }

    delete(key) {
        const item = this.getLocalStorageItem();
        delete item[key];
        this.setLocalStorageItem(item);
    }

    deleteStore() {
        localStorage.removeItem(LOCALSTORAGE_KEY);
    }
}
